<template>
  <main class="main page-inside cart-page">
    <div class="main-wrapper">
      <div class="section cart-section">
        <div class="wrapper">
          <div class="title big">{{ $t('YOUR CART') }}</div>

          <div v-if="loading && !cartItems.length" class="title">{{ $t('Loading...') }}</div>

          <div v-else-if="!cartItems.length" class="cart-empty">
            <div class="title">{{ $t('Your cart is empty') }}</div>
            <router-link to="/products" class="button">{{ $t('GO TO SHOP') }}</router-link>
          </div>

          <div v-else class="cart-grid">
            <div class="cart-items">
              <div v-for="item in cartItems" :key="item.id" class="cart-item">
                <div class="cart-item__left">
                  <img class="cart-item__img" :src="itemImage(item)" :alt="item.title" @error="onImgError" />
                  <div>
                    <div class="title small">{{ item.title }}</div>
                    <div class="desc">{{ $t('Qty:') }} {{ item.count }}</div>
                  </div>
                </div>

                <div class="cart-item__right">
                  <div class="title small">{{ currency }} {{ formatPrice(item.price) }}</div>
                  <button class="button black cart-remove" :disabled="loading" @click="removeFromCart(item.item_id)">X</button>
                </div>
              </div>
            </div>

            <div class="cart-summary">
              <div class="title medium">{{ $t('TOTAL') }}</div>
              <div class="title big summary-total">{{ currency }} {{ totalAmount }}</div>

              <button class="button red" :disabled="loading" @click="goToCheckout">{{ $t('CHECKOUT') }}</button>
              <button class="button black" :disabled="loading" @click="clearCart">{{ $t('CLEAR CART') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import cartService from '@/cart'

export default {
  name: 'Cart',
  props: ['currency'],
  data() {
    return {
      imgDomain: '',
    }
  },
  computed: {
    cartItems() {
      return cartService.state.items
    },
    totalAmount() {
      return cartService.state.totalAmount
    },
    loading() {
      return cartService.state.loading
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
    if (!this.$parent.isAuth) {
      this.$parent.openSignInModal()
      return
    }
    cartService.fetchCart()
  },
  methods: {
    formatPrice(value) {
      return parseFloat(value || 0).toFixed(2)
    },
    itemImage(item) {
      if (this.imgDomain && item.img) {
        return this.imgDomain + item.img
      }
      return require('../assets/item.png')
    },
    onImgError(event) {
      event.target.src = require('../assets/item.png')
    },
    async removeFromCart(itemId) {
      await cartService.removeItem(itemId)
    },
    async clearCart() {
      await cartService.clearCart()
    },
    goToCheckout() {
      this.$parent.openCheckoutModal()
    },
  },
}
</script>

<style scoped>
.cart-page {
  min-height: 100vh; 
  margin-top: 0 !important;
}

.cart-empty {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 32px 0;
}

.cart-grid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 20px;
  margin-top: 24px;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 12px 14px;
}

.cart-item__left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.cart-item__img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
}

.cart-item__right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cart-remove {
  min-width: 40px;
  padding: 8px;
}

.cart-summary {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: fit-content;
}

.summary-total {
  font-size: 38px;
  line-height: 1;
  color: #cd3c3c;
}


.button.red {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9D1712;
  cursor: pointer;
  color: #FFFFFF;
  font-weight: 700;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.button.red:hover {
  background: #AA3220;
}

@media (max-width: 900px) {
  .cart-grid {
    grid-template-columns: 1fr;
  }
}
</style>
